<app-sidebar></app-sidebar>
<div *ngIf="loader" class="spanner-loader">
<mat-spinner></mat-spinner>
</div>
